"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRoamDateUid = exports.toRoamDate = exports.parseRoamDateUid = exports.parseRoamDate = void 0;
const format_1 = __importDefault(require("date-fns/format"));
const parse_1 = __importDefault(require("date-fns/parse"));
const parseRoamDate = (s) => parse_1.default(s, "MMMM do, yyyy", new Date());
exports.parseRoamDate = parseRoamDate;
const parseRoamDateUid = (s) => parse_1.default(s, "MM-dd-yyyy", new Date());
exports.parseRoamDateUid = parseRoamDateUid;
const toRoamDate = (d) => isNaN(d.valueOf()) ? "" : format_1.default(d, "MMMM do, yyyy");
exports.toRoamDate = toRoamDate;
const toRoamDateUid = (d) => isNaN(d.valueOf()) ? "" : format_1.default(d, "MM-dd-yyyy");
exports.toRoamDateUid = toRoamDateUid;
